module.exports = __webpack_public_path__ + "static/media/LogoSSWT.1b5d0d16.svg";